import { render, staticRenderFns } from "./PluginGrid.vue?vue&type=template&id=06107ea4"
import script from "./PluginGrid.vue?vue&type=script&lang=js"
export * from "./PluginGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports